import { Icon } from "../../../icon";
import styles from "../../stepper.module.scss";
import type { StepperStepViewProps } from "./types-step";

const join = (...classes: (string | undefined)[]) => classes.filter(Boolean).join(" ");

export function StepperStepView({
  state,
  number,
  title,
  tag,
  description,
  footer,
  panel,
  testId,
  className,
  classNames,
  ariaLabel,
  ariaCurrent,
  disabled,
  showCheck,
  onSelect,
  rest,
}: StepperStepViewProps) {
  return (
    <li
      className={join(styles.step, className)}
      data-state={state}
      data-testid={testId}
      {...rest}
      aria-current={ariaCurrent}
    >
      <button
        type="button"
        className={join(styles.header, classNames?.header)}
        aria-label={ariaLabel}
        disabled={disabled}
        onClick={onSelect}
      >
        <span className={styles.top}>
          <span className={join(styles.number, classNames?.number)}>
            <span className={styles.digit}>{number}</span>
            {showCheck && <Icon name="check" className={styles.check} />}
          </span>
          {tag && <span className={join(styles.tag, classNames?.tag)}>{tag}</span>}
        </span>
        <span className={styles.body}>
          <span className={join(styles.title, classNames?.title)}>{title}</span>
          {description && (
            <span className={join(styles.description, classNames?.description)}>{description}</span>
          )}
        </span>
        {footer && <span className={join(styles.footer, classNames?.footer)}>{footer}</span>}
      </button>
      <span className={join(styles.separator, classNames?.separator)} aria-hidden />
      {panel && (
        <div className={styles.content}>
          <span className={join(styles.rail, classNames?.rail)} aria-hidden />
          <div className={join(styles.panel, classNames?.panel)}>{panel}</div>
        </div>
      )}
    </li>
  );
}
